import React, { useState } from "react";
import Header from "../layouts/Header";
import "./contact.css";

import Footer from "../layouts/Footer";


export default function Contact() {
  // ✅ STATES MUST BE INSIDE COMPONENT
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const text = `Name: ${name}%0APhone: ${phone}%0AMessage: ${message}`;
    window.open(
      `https://wa.me/919967956503?text=${text}`,
      "_blank"
    );
  };

  return (
    <>
      <Header />

      {/* HERO */}
      <section className="contact-hero">
        <div className="contact-hero-overlay">
          <h1>Contact Us</h1>

          <div className="contact-info-row">
            <div>
              <span>Customer Support</span>
              <strong>support@bizzmark.com</strong>
            </div>

            <div>
              <span>Customer Support</span>
              <strong>+91 99679 56503</strong>
              <small>24 Hours</small>
            </div>

            <div>
              <button
                className="advertise-btn"
                onClick={() => setOpen(true)}
              >
                ADVERTISE NOW
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* POPUP */}
      {open && (
        <div className="popup-overlay">
          <div className="popup-box">
            <button
              className="popup-close"
              onClick={() => setOpen(false)}
            >
              ✕
            </button>

            <h3>Advertise with Bizzmark</h3>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Your Name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />

              <input
                type="tel"
                placeholder="Phone Number"
                required
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />

              <textarea
                placeholder="Your Requirement"
                required
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>

              <button type="submit" className="submit-btn">
                Submit
              </button>
            </form>
          </div>
        </div>
      )}

      {/* CHAT SECTION */}
    <section className="contact-chat">
  <h2>Chat with Us</h2>

  <div className="contact-all-cards">

    {/* CHAT CARD 1 */}
    <div className="contact-card">
      <div className="icon">👤</div>
      <h3>General Queries</h3>
      <p>Have questions? We’re here to help.</p>
      <a
        href="https://wa.me/919967956503"
        target="_blank"
        rel="noreferrer"
        className="whatsapp-btn"
      >
        💬 Chat
      </a>
    </div>

    {/* CHAT CARD 2 */}
    <div className="contact-card">
      <div className="icon">💼</div>
      <h3>Business Support</h3>
      <p>Support for existing business customers.</p>
      <a
        href="https://wa.me/919967956503"
        target="_blank"
        rel="noreferrer"
        className="whatsapp-btn"
      >
        💬 Chat
      </a>
    </div>

    {/* EMAIL CARD */}
    <div className="contact-card">
      <div className="icon">📧</div>
      <h3>Email Support</h3>
      <p>Reach out anytime via email</p>
      <strong>support@bizzmark.com</strong>
    </div>

    {/* CALL CARD */}
    <div className="contact-card">
      <div className="icon">📞</div>
      <h3>Call Support</h3>
      <p>24x7 assistance available</p>
      <strong>+91 99679 56503</strong>
      <span className="support-time">24 Hours</span>
    </div>

  </div>
</section>
<Footer />


    </>
  );
}
